export default __webpack_public_path__ + "static/media/fezes.36f6e439.png";